/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useDropzone} from 'react-dropzone'
import {useQueryClient} from 'react-query'
import {AnimaBaixo} from '../../../../../../../../../../_metronic/assets/animation/styles'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../../../../_metronic/helpers'
import {
  ICreateContractPayment,
  initialValues,
} from '../../../../../addContractPayment/components/CreateContractPaymentHelper'
import AsyncSelect from 'react-select/async'
import makeAnimated from 'react-select/animated'
import {colourStyles} from '../../styles/styles'
import CurrencyInput from 'react-currency-input-field'
import {ContractPayment} from '../core/_models'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

type Props = {
  show: boolean
  handleClose: () => void
  id: string
  uuidRow: any
}
const propertiesSchema = Yup.object().shape({})
const API_URL = process.env.REACT_APP_API_URL || 'api'

const ModalAddContractPayment: React.FC<Props> = ({show, handleClose, id, uuidRow}) => {
  const intl = useIntl()
  const animatedComponents = makeAnimated()
  const {uuid} = useParams()
  const [loading, setLoading] = useState(false)
  const [arquivo, setArquivo] = useState<any>([])
  let token = localStorage.getItem('auth_storage')
  const queryClient = useQueryClient()
  const [net_value, setNetValue] = useState<any>(0)

  useEffect(() => {
    getPropertiesRegistries()
  }, [])

  async function getPropertiesRegistries() {
    const {data} = await axios.get(`${API_URL}/sgt/v1/contracts/${uuid}/payments`)
    const dados: ContractPayment = data.data[0]
    console.log('data', dados)
    if (dados?.contract?.net_value) {
      setNetValue(dados?.contract?.net_value)
    }
  }

  //BUSCA TOKEN NO LOCALSTORAGE
  if (token) token = token.replace(/['"]+/g, '')

  const onDrop = useCallback((acceptedFiles: any) => {
    setArquivo(acceptedFiles[0])
  }, [])

  const remove = (files: any) => {
    acceptedFiles.splice(files, 1)
  }

  const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})

  const files = acceptedFiles.map((file: any) => (
    <AnimaBaixo key={file.proof_payment}>
      <p className='text-primary mt-10 dropzone'>
        <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />
        {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
      </p>
    </AnimaBaixo>
  ))

  //INICIO SUBMIT FORM
  const datasend = new FormData() //formdata object
  const formik = useFormik<ICreateContractPayment>({
    initialValues,
    validationSchema: propertiesSchema,
    onSubmit: async (values) => {
      console.log('valores', values)
      if (values.amount_paid)
        values.amount_paid = values.amount_paid.replaceAll('.', '').replaceAll(',', '.')

      setLoading(true)
      datasend.append('owner_id', values.owner_id || '')
      datasend.append('observations', values.observations || '')
      datasend.append('payday', values.payday || '')
      datasend.append('amount_paid', values.amount_paid || '')
      datasend.set('proof_payment', arquivo)
      datasend.set('reference_date', values.reference_date || '')
      datasend.set('paid', values.paid?.toString() || '')

      try {
        await axios({
          method: 'post',
          url: `${API_URL}/sgt/v1/contracts/${uuid}/payments`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'CONTRACTS.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        queryClient.invalidateQueries('contracts-payment-list-page=1&items_per_page=10')
        remove(files)
        formik.resetForm()
        handleClose()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'CONTRACTS.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
        formik.resetForm()
        remove(files)
        handleClose()
      }
    },
  })

  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getOwners()

      let owners: any = []
      async function getOwners() {
        const {data} = await axios.get(API_URL + '/sgt/v1/owners/select2')
        let Response = data.results
        if (Response) {
          for (const element of Response) {
            const owner: any = {
              value: element.id,
              label: element.name,
            }
            owners.push(owner)
          }
        }
      }
      callback(owners)
    }, 1000)
  }

  const handleInputChangeProject = (event: any) => {
    let inputValue = ''
    inputValue = event.value
    formik.setFieldValue('owner_id', inputValue)
    return {inputValue}
  }

  return (
    <Modal
      id={id}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-600px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='container-xxl p-5'>
        <div className='modal-header py-2 d-flex justify-align-content-between border-0'>
          {/* begin::Close */}
          <span className='fw-bold fs-4 '>
            {intl.formatMessage({id: 'COMMON.CREATE_INSTALLMENT'})}
          </span>
          <div className='btn btn-icon btn-sm btn-light-primary' onClick={handleClose}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div id='kt_account_profile_details' className='collapse show'>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-4'>
              <div className='col-lg-12'>
                <div className='row'>
                  {/* inicio da primeira linha */}
                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      <label className='form-label fs-6 fw-bold required'>
                        {intl.formatMessage({id: 'CONTRACTS.REFERENCE_DATE'})}
                      </label>
                      <div className='d-flex align-items-center position-relative my-1'>
                        <input
                          type='date'
                          className='form-control form-control-solid  ps-6'
                          {...formik.getFieldProps('reference_date')}
                        />
                      </div>
                    </div>

                    <div className='col-lg-6'>
                      <label className='form-label fs-6 fw-bold required'>
                        {intl.formatMessage({id: 'CONTRACTS.PAYMENT_DATE'})}
                      </label>
                      <div className='d-flex align-items-center position-relative my-1'>
                        <input
                          type='date'
                          className='form-control form-control-solid  ps-6'
                          {...formik.getFieldProps('payday')}
                        />
                      </div>
                    </div>
                  </div>
                  {/* fim da primeira linha */}

                  {/* inicio da SEGUNDA linha */}
                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      <label className='form-label fs-6 fw-bold required'>
                        {intl.formatMessage({id: 'OWNERS.TITLE'})}
                      </label>
                      <div className='d-flex align-items-center position-relative my-1'>
                        <AsyncSelect
                          className='form-control form-control-lg form-control-solid p-1 ps-3'
                          styles={colourStyles}
                          components={animatedComponents}
                          cacheOptions
                          loadOptions={loadOptionsProjects}
                          defaultOptions
                          onChange={handleInputChangeProject}
                          placeholder={intl.formatMessage({
                            id: 'OWNERS.TITLE',
                          })}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                            },
                          })}
                        />
                      </div>
                    </div>

                    <div className='col-lg-6'>
                      <label className='form-label fs-6 fw-bold required'>
                        {intl.formatMessage({id: 'CONTRACTS.AMOUNT_PAID'})}
                      </label>
                      <div className='d-flex align-items-center position-relative my-1'>
                        <CurrencyInput
                          className='form-control form-control-lg form-control-solid'
                          intlConfig={{locale: 'pt-BR', currency: 'BRL'}}
                          decimalScale={2}
                          allowDecimals={true}
                          onValueChange={(value) => formik.setFieldValue('amount_paid', value)}
                        />
                      </div>
                    </div>
                  </div>
                  {/* fim da SEGUNDA linha */}

                  {/* Inicio da quinta linha */}
                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
                    </label>

                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      title={intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
                      placeholder={intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
                      {...formik.getFieldProps('observations')}
                    />
                  </div>
                  {/* Inicio da quinta linha */}

                  {/* Inicio da quarta linha */}
                  <div className='row mb-3'>
                    <div className='col-lg-6'>
                      <label className='form-label fs-6 fw-bold d-flex'>
                        {intl.formatMessage({id: 'COMMON.PAID_OUT'})}
                      </label>
                      <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10 '>
                        <label className='form-check-label'>
                          {intl.formatMessage({id: 'COMMON.NO'})}
                          &nbsp;
                        </label>
                        <input
                          className='form-check-input w-45px h-30px'
                          type='checkbox'
                          checked={formik.values.paid === true ? true : false}
                          {...formik.getFieldProps('paid')}
                        />

                        <label className='form-check-label'>
                          {intl.formatMessage({id: 'COMMON.YES'})}
                        </label>
                      </div>
                    </div>

                    <div className='col-lg-6 text-center  align-middle'>
                      <label className='form-label fs-6 fw-bold mb-0'>
                        {intl.formatMessage({id: 'COMMON.AMOUNT_PAYABLE'})}
                      </label>
                      <div className='col-lg-12 col-form-label fw-bold fs-2  text-success mt-n2'>
                        {net_value ? 'R$ ' + net_value.replace('.', ',') : ' '}
                      </div>
                    </div>
                  </div>
                  {/* fim da quarta linha */}

                  <div className='row mb-3'>
                    <label className='col-lg-12 col-form-label required fw-bold fs-6'>
                      {intl.formatMessage({id: 'COMMON.PAYMENT_PROOF'})}
                    </label>
                    <div className='dropzone' {...getRootProps()}>
                      <div className='dz-message needsclick'>
                        <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                        <div className='ms-4'>
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                              {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                            </h3>
                          ) : (
                            <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                              {intl.formatMessage({id: 'DROPZONE.COMMON_TITLE'})}
                            </h3>
                          )}

                          <label
                            htmlFor='license_documentation'
                            className='fs-7 fw-semibold text-gray-400'
                          >
                            {intl.formatMessage({id: 'DROPZONE.SUBTITLE'})}
                          </label>
                        </div>
                      </div>

                      <p> {files}</p>
                    </div>
                  </div>

                  {/* Submit */}
                  <div className='d-flex justify-content-end py-6'>
                    <button type='submit' className='btn btn-primary' disabled={loading}>
                      {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
                {/* ----------------------------------------------------------------------------------- */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddContractPayment}
